"use client"

import { type ComponentProps } from "react"
import { useInView } from "react-intersection-observer"

import type { UnlikelyProduct } from "@unlikelystudio/commerce-connector"

import { useAlgoliaRecommendations } from "~/hooks/useAlgoliaRecommendations"
import { ProductsSlider } from "~/components/ui/ProductsSlider/index.client"

export function AlgoliaRecommendations({
  currentProductId = null,
  title,
}: {
  currentProductId?: UnlikelyProduct["id"]
} & Pick<ComponentProps<typeof ProductsSlider>, "title">) {
  const { ref, inView } = useInView()

  const { data, isLoading } = useAlgoliaRecommendations(currentProductId, { enabled: inView })

  if (!data && !isLoading && inView) return null

  return <ProductsSlider ref={ref} isLoading={isLoading} title={title} products={data?.filter(Boolean) ?? []} />
}
